// @flow
import React, { type Node } from 'react';
import { IfFeature } from '@tectonics/prs/feature';
import { useCurrentAllFeatures } from '@tectonics/prs/payment-spec';

import { InformationBox } from '../../../../../organisms/information-box';
import {
  SimpleTipsList,
  SimpleTipItem,
  SimpleTipsSortedSubList,
  SimpleTipsSubListItem,
} from '../commons/simple-tips';

export function ServipagInfo(): Node {
  const allFeatures = useCurrentAllFeatures();

  return (
    <>
      <IfFeature allFeatures={allFeatures} wanted="display_servipag_instructions">
        <SimpleTipsList>
          <SimpleTipItem>
            Serás direccionado a la plataforma de Servipag.
          </SimpleTipItem>

          <SimpleTipItem>
            Podrás elegir pagar con:

            <SimpleTipsSortedSubList>
              <SimpleTipsSubListItem>Cupón de Pago</SimpleTipsSubListItem>
              <SimpleTipsSubListItem>Cuenta Corriente / Cuenta Vista</SimpleTipsSubListItem>
              <SimpleTipsSubListItem>Tarjeta Casas Comerciales</SimpleTipsSubListItem>
              <SimpleTipsSubListItem>Tarjeta de Débito</SimpleTipsSubListItem>
            </SimpleTipsSortedSubList>
          </SimpleTipItem>
        </SimpleTipsList>
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="display_servipag_other_methods">
        <InformationBox>
          En caso de no poder realizar tu pago con el método que elegiste,
          tendrás siempre la opción de generar un nuevo
          pedido con: WebPay, MultiCaja y Sencillito.
        </InformationBox>
      </IfFeature>
    </>
  );
}
